import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";
import { SessionManager } from "../../SessionManager/SessionManager";

export class PaymentGatewayAPIHandler {
    
    public static shared = new PaymentGatewayAPIHandler()
    
    apiHandler = BaseAPICallsHandler.shared
    serverConfig = ServerConfig.shared
    networkUtils = NetworkUtils.shared
    sessionManager = SessionManager.shared

    // dependency injection here
    constructor();
    constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
    public constructor(...params: any[]) {
        if(params.length >= 3) {
            this.apiHandler = params[0];
            this.serverConfig = params[1];
            this.networkUtils = params[2];
        }
    };


    /* Deprecated APIs
    public async initiatePayment(actionCardId: string): Promise<any> {
        let url = this.serverConfig.paymentGatewayAPIs.createInstanceAPI;
        const authHeaders = this.networkUtils.addAuthHeaders({});

        try {
            
            const response = await this.apiHandler.makePostRequest(authHeaders, url, {actionCardId}); 
            const paymentInstance = response.data.paymentInstance
            return Promise.resolve(paymentInstance);

        } catch (err) {
            return Promise.reject(err);
        }
    }

    public async verifyPayment(orderId: string, paymentId: string, signature: string): Promise<boolean> {
        let url = this.serverConfig.paymentGatewayAPIs.verifyPaymentAPI;
        const authHeaders = this.networkUtils.addAuthHeaders({});
        
        try {
            await this.apiHandler.makePostRequest(authHeaders, url, {orderId, paymentId, signature});
            return Promise.resolve(true);
        } catch (err) {
            return Promise.reject(err);
        }
    }

    */


}